var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Assignment } from "./Assignment";
var AssignedAssessmentGroup = /** @class */ (function (_super) {
    __extends(AssignedAssessmentGroup, _super);
    function AssignedAssessmentGroup() {
        var _this = _super.call(this) || this;
        _this.Type = "AssessmentGroup";
        return _this;
    }
    Object.defineProperty(AssignedAssessmentGroup.prototype, "AssessmentGroupId", {
        get: function () {
            return this.assessmentGroupId;
        },
        set: function (v) {
            this.assessmentGroupId = v;
        },
        enumerable: true,
        configurable: true
    });
    AssignedAssessmentGroup.prototype.getAssessmentItems = function () {
        return this.Items.filter(function (i) { return i.Type == "Assessment"; }).map(function (i) { return i; });
    };
    Object.defineProperty(AssignedAssessmentGroup.prototype, "Name", {
        get: function () {
            return this.name;
        },
        set: function (v) {
            this.name = v;
        },
        enumerable: true,
        configurable: true
    });
    return AssignedAssessmentGroup;
}(Assignment));
export { AssignedAssessmentGroup };



// WEBPACK FOOTER //
// ./src/app/shared/models/AssignedAssessmentGroup.ts.pre-build-optimizer.js